module.exports = __webpack_public_path__ + "static/img/cloud.194a2f28.png";